import type { TemplateOnlyComponent } from '@ember/component/template-only';
import Svg from 'tio-employee/components/svg';
import { t } from 'ember-intl';
import transitionTo from 'ember-router-helpers/helpers/transition-to';
import Button from 'tio-ui/components/button';
import { on } from '@ember/modifier';

export interface EnrollmentCompleteSignature {
  Element: HTMLDivElement;
}

const EnrollmentCompleteComponent: TemplateOnlyComponent<EnrollmentCompleteSignature> = <template>
  <div class="tio-flex-center my-4">
    <Svg
      @name="enrollment-complete"
      width="150px"
      role="img"
      aria-label={{t "svg.enrollment_complete"}}
    />
  </div>
  <h2 class="text-4xl mb-6 text-center">{{t "syf.enrollment.submitted.enrollment_complete"}}</h2>
  <section class="my-10">
    <div class="grid md:grid-cols-6 mx-8">
      <h3 class="font-semibold mb-4 md:col-start-2 md:col-span-3">
        {{t "syf.enrollment.submitted.what_happens_now"}}
      </h3>
      <ul class="md:col-start-2 md:col-span-4 list-disc ml-8 text-sm md:text-base">
        <li class="my-1.5">
          {{t "syf.enrollment.submitted.you_are_now_enrolled"}}
        </li>
      </ul>
    </div>
    <div class="tio-flex-center mt-16">
      {{! TODO: Verify button route }}
      <Button {{on "click" (transitionTo "authenticated.syf.post-enrollment")}} class="m-8 w-48">
        {{t "done"}}
      </Button>
    </div>
  </section>
</template>;

export default EnrollmentCompleteComponent;
